import { render, staticRenderFns } from "./bond_general_tab.vue?vue&type=template&id=754283da&scoped=true&"
import script from "./bond_general_tab.vue?vue&type=script&lang=js&"
export * from "./bond_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754283da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754283da')) {
      api.createRecord('754283da', component.options)
    } else {
      api.reload('754283da', component.options)
    }
    module.hot.accept("./bond_general_tab.vue?vue&type=template&id=754283da&scoped=true&", function () {
      api.rerender('754283da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/bond/location/tabs/bond_general_tab.vue"
export default component.exports